import { FireOutbreakOccurrenceEnum } from '../enum/FireOutbreakOccurence.enum'
import { FireOutbreakReactionEnum } from '../enum/FireOutbreakReaction.enum'
import { FireRiskEnum } from '../enum/FireRisk.enum'
import { format } from 'date-fns'

export class FireOutbreak {
	private static readonly RISK_LABELS: Record<FireRiskEnum, string> = {
		[FireRiskEnum.NONE]: 'Nulo',
		[FireRiskEnum.SMALL]: 'Pequeno',
		[FireRiskEnum.MEDIUM]: 'Médio',
		[FireRiskEnum.HIGH]: 'Alto',
		[FireRiskEnum.HIGHEST]: 'Muito Alto',
	}

	seen: boolean = true

	constructor(
		readonly id: string,
		readonly detectedAt: Date,
		readonly statedAt: Date,
		readonly farm: string,
		readonly farmId: string,
		readonly detectionConfidence: number,
		readonly satellite: string,
		readonly occurrence: FireOutbreakOccurrenceEnum,
		readonly dangerLevel: FireRiskEnum,
		readonly latitude: number,
		readonly longitude: number,
		readonly reaction?: FireOutbreakReactionEnum,
		readonly radiance?: number,
	) {}

	get riskLabel(): string {
		return FireOutbreak.RISK_LABELS[this.dangerLevel]
	}

	get detectedAtLabel(): string {
		return format(this.detectedAt, 'dd/MM/yyyy HH:mm')
	}

	get statedAtLabel(): string {
		return format(this.statedAt, 'dd/MM/yyyy HH:mm')
	}

	get detectionConfidenceLabel(): string {
		return `${this.detectionConfidence}%`
	}

	get radianceLabel(): string {
		if (!this.radiance) return 'N/A'
		return `${this.radiance} W`
	}

	get occurrenceLabel(): string {
		return this.occurrence === FireOutbreakOccurrenceEnum.FARM ? 'Fazenda' : 'Buffer'
	}

	haveSeenAlert() {
		this.seen = true
	}
}
